module.exports = __webpack_public_path__ + "static/media/patrick.2932ba84.jpg";